import { useState, useEffect, useMemo } from "react";
import { cloneDeep } from "lodash";
import { objectUtil } from "../utils";

const useChartData = ({ data, isBarChart, metricsConfig, deleteNullMetrics }) => {
  const [opacity, setOpacity] = useState();
  const [filteredMetricsConfig, setFilteredMetricsConfig] = useState(metricsConfig);

  const dataKeys = useMemo(() => {
    if (data && data[0]?.metrics) {
      return Object.keys(data[0].metrics);
    }
  }, [data]);

  const formattedData = useMemo(() => {
    if (data && data?.length > 0) {
      const result = data.map((record) => {
        const obj = {};
        obj[Object.keys(record)[0]] = record[Object.keys(record)[0]];

        return { ...obj, ...record?.metrics };
      });

      return result;
    }
  }, [data]);

  const maxY = useMemo(() => {
    const func = isBarChart ? "getSum" : "getMaxValue";

    const rightYAxisMetrics = [];

    dataKeys &&
      dataKeys.forEach((metric) => {
        if (metricsConfig[metric]?.isRightYAxis) {
          rightYAxisMetrics.push(metric);
        }
      });

    let filteredData = cloneDeep(data);
    if (rightYAxisMetrics?.length > 0) {
      filteredData = filteredData.map((record) => {
        rightYAxisMetrics.forEach((e) => delete record?.metrics[e]);

        return record;
      });
    }

    const result = filteredData?.reduce((prev, current) => {
      return objectUtil[func](prev?.metrics) > objectUtil[func](current?.metrics) ? prev : current;
    }, 0);

    return objectUtil[func](result?.metrics);
  }, [data]);

  useEffect(() => {
    if (dataKeys) {
      const opacityObject = {};

      dataKeys.forEach((key) => {
        opacityObject[key] = 1;
      });

      setOpacity(opacityObject);
    }
  }, [dataKeys]);

  useEffect(() => {
    const filtered = cloneDeep(metricsConfig);
    if (dataKeys && deleteNullMetrics) {
      Object.keys(filtered).map((key) => {
        if (!dataKeys.includes(key)) {
          delete filtered[key];
        }
      });
    }
    setFilteredMetricsConfig(filtered);
  }, [dataKeys, metricsConfig, deleteNullMetrics]);

  return { formattedData, filteredMetricsConfig, maxY, dataKeys, opacity, setOpacity };
};

export default useChartData;
